'use client';

import { TCatalog } from '@/actions/catalogs/types';
import { GetExperiencesResponse } from '@/actions/experiences/types';
import Banner from '@/components/Banner';
import { Favourites } from '@/components/ExperiencesSections/Favourites';
import { Gallery } from '@/components/ExperiencesSections/Gallery';
import NavBreadcrumb from '@/components/NavBreadcrumb';
import { Reviews } from '@/components/Reviews';
import { useTranslation } from '@/contexts/dictionaryContext';
import { useLocale } from '@/hooks/useLocale';
import { normalizeRegion } from '@/utils/normalizeRegion';
import { useParams } from 'next/navigation';
import { useMemo } from 'react';

interface IExperiences {
  experiences: GetExperiencesResponse[];
  catalogExperiences: TCatalog[];
}
export default function Experiences({
  experiences,
  catalogExperiences,
}: IExperiences) {
  const { experiences: dict } = useTranslation();
  const lang = useLocale();
  const params = useParams();

  const normalizedRegion = normalizeRegion(params.region as string)!;

  const imgSrc = useMemo(() => {
    if (normalizedRegion === 'sicily') {
      return `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/1920w_webp/image/static/experiences/macro/intro.jpg`;
    }

    return `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/1920w_webp/image/static/experiences/macro/esperienze-puglia.jpg`;
  }, [normalizedRegion]);

  return (
    <main className="px-sm md:px-md desktop:px-lg">
      <NavBreadcrumb.Root className="text-gray-600 py-8">
        <NavBreadcrumb.Item path={lang === 'en' ? '/' : `/${lang}`}>
          {dict.breadcrumbHome}
        </NavBreadcrumb.Item>
        <NavBreadcrumb.Item>{dict.breadcrumbExperiences}</NavBreadcrumb.Item>
      </NavBreadcrumb.Root>

      <Banner
        className="flex flex-col justify-center text-white text-center leading-[1.6] desktop:p-24"
        imgSrc={imgSrc}
        alt="Tours & experiences for holidays in Sicily">
        <h1 className="text-4xl font-semibold mb-2 font-title">
          {dict.bannerTitle[normalizedRegion]}
        </h1>
        <p className="hidden desktop:block desktop:text-lg desktop:w-4/5 mx-auto font-text">
          {dict.bannerSubtitle[normalizedRegion]}
        </p>
      </Banner>

      <Gallery catalogExperiences={catalogExperiences} />

      <Favourites experiences={experiences} />

      <Reviews />
    </main>
  );
}
